// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/components/layouts'

export const asyncRouterMap = [
  // {
  //   path: '/',
  //   name: 'index',
  //   component: BasicLayout,
  //   meta: { title: 'menu.home' },
  //   redirect: '/dashboard',
  //   children: [
  //     {
  //       path: '/dashboard',
  //       name: 'dashboard',
  //       component: () => import('@/views/dashboard'),
  //       meta: { title: 'custom.menu.dashboard', keepAlive: true, icon: 'iconyibiaopan' }
  //     },
  //     {
  //       path: '/robot&studio',
  //       name: 'Robot and Designer',
  //       component: () => import('@/views/robotManage/list'),
  //       meta: { title: 'custom.menu.robot', keepAlive: true, icon: 'iconjiqiren' }
  //     },
  //     {
  //       path: '/bpm',
  //       name: 'Process management',
  //       component: () => import('@/views/dashboard'),
  //       meta: { title: 'custom.menu.manage-process', keepAlive: true, icon: 'iconliucheng' }
  //     },
  //     {
  //       path: '/task',
  //       name: 'task management',
  //       component: () => import('@/views/taskManage/index'),
  //       meta: { title: 'custom.menu.manage-task', keepAlive: true, icon: 'iconrenwuguanli' }
  //     },
  //     {
  //       path: '/variant',
  //       name: 'dashVariable managementboard',
  //       component: () => import('@/views/dashboard'),
  //       meta: { title: 'custom.menu.manage-variable', keepAlive: true, icon: 'iconbianliangguanli' }
  //     },
  //     {
  //       path: '/taskdata',
  //       name: 'Task data',
  //       component: () => import('@/views/dashboard'),
  //       meta: { title: 'custom.menu.taskdata', keepAlive: true, icon: 'iconrenwushuju' }
  //     },
  //     {
  //       path: '/log',
  //       name: 'Business log',
  //       component: () => import('@/views/dashboard'),
  //       meta: { title: 'custom.menu.log', keepAlive: true, icon: 'iconyewurizhi' }
  //     }
  //   ]
  // },
  // {
  //   path: '*', redirect: '/404', hidden: true
  // }
]

/**
 * 基础路由，目前并没有动态权限分配，请把路由统一写在 constantRouterMap 中
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'gittoken',
        name: 'gittoken',
        component: () => import('@/views/loginOAuth/GitToken')
      },
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      }
    ]
  },

  {
    path: '/test',
    component: BlankLayout,
    redirect: '/test/home',
    children: [
      {
        path: 'home',
        name: 'TestHome',
        component: () => import('@/views/Home')
      }
    ]
  },

  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  },
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: 'menu.home' },
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: 'custom.menu.dashboard', keepAlive: true, icon: 'iconyibiaopan' }
      },
      // 机器人与设计器
      {
        path: '/robot&studio',
        name: 'Robot and Designer',
        component: RouteView,
        hideChildrenInMenu: true,
        meta: { title: 'custom.menu.robot', keepAlive: false, icon: 'iconxukeguanli' },
        redirect: '/robot&studio/list',
        children: [
          {
            path: 'list',
            name: 'Robot and Designer List',
            component: () => import('@/views/robotManage/list'),
            meta: { title: '机器人与设计器列表页', keepAlive: true }
          },
          {
            path: 'purchase',
            name: 'Robot and Designer Purchase',
            component: () => import('@/views/robotManage/purchase'),
            meta: { title: '机器人与设计器购买页', keepAlive: false }
          }
        ]
      },
      // 流程管理
      {
        path: '/bpm',
        name: 'Process management',
        component: () => import('@/views/processManage/list'),
        alwaysShow: true,
        meta: { title: 'custom.menu.manage-process', keepAlive: false, icon: 'iconliucheng' }
      },
      // 流程配置
      {
        path: 'set',
        name: 'Process set',
        hidden: true,
        component: () => import('@/views/processManage/set'),
        meta: { keepAlive: false }
      },
      // 任务管理
      {
        path: '/task',
        name: 'task management',
        component: () => import('@/views/taskManage/index'),
        meta: { title: 'custom.menu.manage-task', keepAlive: false, icon: 'iconrenwuguanli' }
      },
      // 任务管理-录像回放
      {
        path: '/task/:id',
        name: 'task play',
        hidden: true,
        component: () => import('@/views/taskManage/play')
      },
      // 变量管理
      {
        path: '/variant',
        name: 'dashVariable managementboard',
        component: () => import('@/views/variablesManage/index'),
        meta: { title: 'custom.menu.manage-variable', keepAlive: false, icon: 'iconbianliangguanli' }
      },
      // 变量管理 -- 访问记录
      {
        path: '/record',
        hidden: true,
        component: () => import('@/views/variablesManage/record')
      },
      // 任务数据
      {
        path: '/taskdata',
        name: 'Task data',
        component: () => import('@/views/taskDataManage/index'),
        meta: { title: 'custom.menu.taskdata', keepAlive: false, icon: 'iconrenwushuju' }
      },
      // 任务数据 --- 查看数据
      {
        path: '/taskViewData/:queueName/:queueId',
        hidden: true,
        component: () => import('@/views/taskDataManage/dataView')
      },
      // 任务数据 --- 查看数据 --- 访问日志
      {
        path: '/taskViewLogs/:queueName/:itemNo',
        hidden: true,
        component: () => import('@/views/taskDataManage/logsView')
      },
      // 业务日志
      {
        path: '/log',
        name: 'Business log',
        component: () => import('@/views/businessLog/list'),
        meta: { title: 'custom.menu.log', keepAlive: true, icon: 'iconyewurizhi' }
      },
      // 许可管理
      {
        path: '/application',
        name: 'Application Management',
        component: RouteView,
        hideChildrenInMenu: true,
        hidden: true,
        meta: { title: 'custom.menu.application', keepAlive: true, icon: 'iconxukeguanli' },
        redirect: '/application/index',
        children: [
          {
            path: 'index',
            name: 'Application Management Index',
            component: () => import('@/views/licenseManage/index'),
            meta: { title: '能力管理', keepAlive: false }
          },
          {
            path: 'list',
            name: 'Application Management List',
            component: () => import('@/views/licenseManage/list'),
            meta: { title: '列表页', keepAlive: false }
          },
          {
            path: 'new',
            name: 'Application Management New',
            component: () => import('@/views/licenseManage/new'),
            meta: { title: '新增页', keepAlive: false }
          }
        ]
      },
      {
        path: '/private',
        component: RouteView,
        hidden: true,
        children: [
          {
            path: 'operationLog',
            name: 'Operation Log',
            component: () => import('@/views/private/operationLog'),
            meta: { title: '我的操作日志', keepAlive: true }
          },
          {
            path: 'message',
            name: 'message',
            component: () => import('@/views/private/message'),
            meta: { title: '消息列表', keepAlive: true }
          },
          {
            path: 'order',
            name: 'order',
            component: () => import('@/views/private/order'),
            meta: { title: '我的订单', keepAlive: true }
          },
          {
            path: 'orderDetail/:outTradeNo',
            name: 'order Detail',
            component: () => import('@/views/private/orderDetail'),
            meta: { title: '订单详情', keepAlive: false }
          }
        ]
      },
      // 我的账户
      {
        path: '/my',
        name: 'My',
        hidden: true,
        component: () => import('@/views/my/index'),
        redirect: '/my/basic',
        children: [
          // 基本设置
          {
            path: 'basic',
            component: () => import('@/views/my/basicSettings'),
            meta: { title: '基本设置', keepAlive: true }
          },
          // 安全设置
          {
            path: 'security',
            component: () => import('@/views/my/securitySetting'),
            meta: { title: '安全设置', keepAlive: true }
          },
          // 账户绑定
          {
            path: 'bind',
            component: () => import('@/views/my/accountBinding'),
            meta: { title: '账户绑定', keepAlive: true }
          },
          // 推荐有礼
          {
            path: 'gift',
            component: () => import('@/views/my/recommendedGift'),
            meta: { title: '推荐有礼', keepAlive: true }
          }
        ]
      },
      // 我的卡包
      {
        path: '/card',
        name: 'Card management',
        hidden: true,
        component: () => import('@/views/ECard/list'),
        meta: { keepAlive: false }
      },
      // 报表
      {
        path: '/reportforms',
        name: 'Reportforms',
        component: RouteView,
        // hideChildrenInMenu: false,
        redirect: '/reportforms/taskReport',
        meta: { title: 'custom.menu.reportforms', keepAlive: false, icon: 'iconbaobiaozhongxin' },
        children: [
          // 任务报表
          {
            path: '/taskReport',
            name: 'Task Report',
            component: () => import('@/views/reportforms/taskReport'),
            meta: { title: 'custom.menu.reportforms-task', keepAlive: false }
          },
          // 机器人报表
          {
            path: '/robotReport',
            name: 'Robot Report',
            component: () => import('@/views/reportforms/robotReport'),
            meta: { title: 'custom.menu.reportforms-robot', keepAlive: false }
          },
          // 流程报表
          {
            path: '/processReport',
            name: 'Process Report',
            component: () => import('@/views/reportforms/processReport'),
            meta: { title: 'custom.menu.reportforms-process', keepAlive: false }
          },
          // 投资回报-报表
          {
            path: '/roiReport',
            name: 'Return On Investment',
            component: () => import('@/views/reportforms/roiReport'),
            meta: { title: 'custom.menu.reportforms-roi', keepAlive: false }
          }
        ]
      },
      // 财务中心
      {
        path: '/finance',
        name: 'Financial Center',
        component: RouteView,
        // hideChildrenInMenu: true,
        hidden: true,
        meta: { title: 'custom.menu.finance.title', keepAlive: false, icon: 'iconcaiwuzonglan' },
        redirect: '/finance/index',
        children: [
          {
            path: '/finance/index',
            name: 'Financial overview',
            component: () => import('@/views/financialCenter/overview'),
            meta: { title: 'custom.menu.finance.overview', keepAlive: false }
          },
          {
            path: '/finance/details',
            name: 'Financial details',
            component: () => import('@/views/financialCenter/details'),
            meta: { title: 'custom.menu.finance.details', keepAlive: false }
          }
        ]
      }
    ]
  },
  {
    path: '/pay',
    name: 'pay',
    component: BlankLayout,
    hidden: true,
    meta: { title: '支付页', keepAlive: false },
    redirect: '/pay/wx',
    children: [
      {
        path: 'wx',
        name: 'pay-wx',
        component: () => import('@/views/robotManage/payWx')
      },
      {
        path: 'card',
        name: 'pay-card',
        component: () => import('@/views/robotManage/payCard')
      }
    ]
  },
  {
    path: '*', redirect: '/404', hidden: true
  }
]
